import type { ReactNode } from 'react';
import { AlertCircle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type ReviewSummaryStatus = 'ok' | 'attention' | 'not-needed';

export type ReviewSummaryItem = {
  label: string;
  value: ReactNode;
};

export const ReviewSummaryCard = ({
  icon: Icon,
  title,
  status,
  items,
  onEdit,
}: {
  icon: LucideIcon;
  title: string;
  status: ReviewSummaryStatus;
  items: ReviewSummaryItem[];
  onEdit: () => void;
}) => (
  <article className={`ai-review-card${status === 'not-needed' ? ' is-not-needed' : ''}`}>
    <header>
      <span className="ai-review-card-icon" aria-hidden="true"><Icon size={17} /></span>
      <strong>{title}</strong>
      {status === 'attention' && (
        <span className="ai-review-card-badge">
          <AlertCircle size={12} /> Requer atenção
        </span>
      )}
      {status !== 'not-needed' && (
        <button type="button" onClick={onEdit} aria-label={`Editar ${title}`}>Editar</button>
      )}
    </header>
    {status === 'not-needed' ? (
      <p className="ai-review-card-empty">Não é necessária com os recursos escolhidos.</p>
    ) : (
      <dl>
        {items.map((item) => (
          <div key={item.label}>
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </div>
        ))}
      </dl>
    )}
  </article>
);
